import React, { useState,useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import {Routes, Route} from 'react-router-dom'

function CalculatorDash (props){
    return(
        <>
            <h1>Calculator Dash Page</h1>
        </>
    )
}
export default CalculatorDash